export interface BlindConfig {
  enabled?: boolean;
  mask_name?: boolean;
  mask_email?: boolean;
  mask_title?: boolean;
  mask_department?: boolean;
  mask_manager?: boolean;
  mask_hire_date?: boolean;
  mask_location?: boolean;
  mask_photo?: boolean;
}

export interface BlindMask {
  name?: boolean;
  email?: boolean;
  title?: boolean;
  department?: boolean;
  manager?: boolean;
  hireDate?: boolean;
  location?: boolean;
  photo?: boolean;
}

// Maps a chapter's blind-review config to the fields SubmittedApp omits; null when blind review is off.
export const blindMaskFrom = (blind: BlindConfig | null | undefined): BlindMask | null => {
  if (!blind?.enabled) return null;
  return {
    name: blind.mask_name,
    email: blind.mask_email,
    title: blind.mask_title,
    department: blind.mask_department,
    manager: blind.mask_manager,
    hireDate: blind.mask_hire_date,
    location: blind.mask_location,
    photo: blind.mask_photo,
  };
};
